import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GIButton, Modal } from 'app-components';
import { useDispatch, useSelector } from 'react-redux';

import { responseCheck, useApiHandler } from '../hooks/useApiHandler';
import { ROOT_STATE } from '../../../../store/store.types';
import { StyledModal } from '../constants/ticketlist.styled';
import { IReopenTicketModal } from '../constants/ticketlist.interface';
import { API_STATUS_CODES } from '../../../../constants/common.constants';
import { getViewDetailUrl } from '../constants/ticketlist.utils';

export const ReopenTicketModal = ({ onClose }: IReopenTicketModal) => {
    const dispatch = useDispatch();
    const {
        modalData: { ticketId },
    } = useSelector((state: ROOT_STATE) => state.ticketMgmt.ticketsList);

    const { reopenTicketAPI } = useApiHandler();

    const onSubmit = async () => {
        const payload = {
            ticketId: ticketId,
            csrftoken: window.csrf_token,
        };
        const response = await reopenTicketAPI(dispatch, payload);

        if (response.statusCode === API_STATUS_CODES.OK || responseCheck(response)) {
            window.location.href = getViewDetailUrl(ticketId);
        }

        onClose();
    };

    return (
        <StyledModal>
            <Modal id="reopenTicketModal" data-testid="reopen-ticket-modal">
                <Modal.Header
                    id="reopenTicketModalHeader"
                    titleId="ticketList.modal.reopenTicket.header"
                    data-testid="reopen-ticket-modal-header"
                    onHide={onClose}
                />
                <Modal.Body data-testid="reopen-ticket-modal-body">
                    <FormattedMessage id="ticketList.modal.reopenTicket.body" />
                </Modal.Body>
                <Modal.Controls data-testid="reopen-ticket-modal-controls">
                    <GIButton
                        id="reopenTicketModalNoButton"
                        onClickHandler={onClose}
                        variant="secondary"
                        labelId="button.cancel"
                    />
                    <GIButton
                        id="reopenTicketModalYesButton"
                        onClickHandler={onSubmit}
                        variant="primary"
                        labelId="ticketList.btn.reopen"
                    />
                </Modal.Controls>
            </Modal>
        </StyledModal>
    );
};
